import types from './mutations_types';

const mutations = {
  [types.MULTIPLEID_COORDINATE_LIST](state, multipleId) {
    state.multipleId = multipleId;
  }
};

export default mutations;
